<div class="auth-settings-root">
  <form [formGroup]="form">
    <div class="mb-3">
      <input type="checkbox" (change)="checkChanged()" [formControl]="samlEnabled" />
      <span class="uv-checkbox-label auth-settings-heading-1">Enable SAML Single Sign-On</span>
    </div>
    <div class="mb-3 auth-settings-row-1">
      <span class="auth-settings-heading-2">Basic Settings</span>
    </div>

    <div style="display: grid; grid-template-columns: 200px 350px; row-gap: 20px; column-gap: 0px;"
      class="mb-3 auth-settings-row-2">
      <span class="auth-settings-label">Application Entity Identifier:</span>
      <div>
        <input type="text" pInputText class="auth-settings-app-entity-id" [formControl]="appEntityId" />
        @if (appEntityId.hasError('required')) {
        <div>
          <div class="auth-settings-app-entity-id-error alert alert-danger">
            This field is required.
          </div>
        </div>
        }
      </div>
      <span class="auth-settings-label">Provider Identifier:</span>
      <div>
        <input type="text" pInputText class="auth-settings-provider-id" [formControl]="providerId" />
        @if (providerId.hasError('required')) {
        <div>
          <div class="auth-settings-provider-id-error alert alert-danger">
            This field is required.
          </div>
        </div>
        }
      </div>
      <span class="auth-settings-label">Provider Login URL:</span>
      <div>
        <input type="text" pInputText class="auth-settings-provider-login-url" [formControl]="providerLoginUrl" />
        @if (providerLoginUrl.hasError('required')) {
        <div>
          <div class="auth-settings-provider-login-url-error alert alert-danger">
            This field is required.
          </div>
        </div>
        }
      </div>
      <span class="auth-settings-label">Provider Logout URL:</span>
      <div>
        <input type="text" pInputText class="auth-settings-provider-logout-url" [formControl]="providerLogoutUrl" />
        @if (providerLogoutUrl.hasError('required')) {
        <div>
          <div class="auth-settings-provider-logout-url-error alert alert-danger">
            This field is required.
          </div>
        </div>
        }
      </div>
    </div>
    <div class="mb-3 auth-settings-row-2">
      <span class="auth-settings-label">Provider Signing Certificate</span>
    </div>
    <div class="mb-3 auth-settings-row-2" style="margin-bottom: 5px;">
      <textarea class="form-control auth-settings-provider-certificate" [formControl]="providerCertificate"></textarea>
    </div>
    @if (providerCertificate.hasError('required')) {
    <div class="mb-3 auth-settings-row-2">
      <div class="auth-settings-provider-certificate-error alert alert-danger">
        This field is required.
      </div>
    </div>
    }
    <div class="auth-settings-divider">
    </div>
    <div>
      <div style="display: inline-block; width: 50px;">&nbsp;</div>
      <button pButton (click)="onSave()" [disabled]="!enableSave()" label="Save SAML SSO Settings"></button>
    </div>
  </form>
</div>